import { EcardEmailForm } from './EcardEmailForm';
export default EcardEmailForm;
